"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Taobao = _interopRequireDefault(require("@rsuite/icon-font/lib/platform/Taobao"));

// Generated by script, don't edit it please.
var Taobao = (0, _createSvgIcon["default"])({
  as: _Taobao["default"],
  ariaLabel: 'taobao',
  category: 'platform',
  displayName: 'Taobao'
});
var _default = Taobao;
exports["default"] = _default;
module.exports = exports.default;